<template>
    <el-card class="container" shadow="never">
        <div slot="header">
            <div class="desciconLarge"></div>
            <span class="font18">身份认证</span>
        </div>
        <el-form class="authForm" ref="authForm" :rules="rules" :model="authForm" label-width="130px" label-position="left">
            <el-form-item label="昵称" prop="clientName">
                <el-input placeholder="请输入昵称" disabled v-model="authForm.clientName"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input placeholder="请输入邮箱" v-model="authForm.email"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="name">
                <el-input placeholder="请输入真实姓名" v-model="authForm.name"></el-input>
            </el-form-item>
            <el-form-item label="证件类型">
                <el-radio border :label="undefined" v-model="authForm.cardType">中国居民身份证</el-radio>
                <!-- <el-radio border :label="414" v-model="authForm.cardType">定居国外的中国公民护照</el-radio>
                <el-radio border :label="516" v-model="authForm.cardType">港澳居民来往内地通行证</el-radio>
                <el-radio border :label="511" v-model="authForm.cardType">台湾居民来往大陆通行</el-radio>
                <el-radio border :label="553" v-model="authForm.cardType">外国人永久居留证</el-radio> -->
            </el-form-item>
            <el-form-item label="证件号码" prop="idCard">
                <el-input placeholder="请输入证件号码" v-model="authForm.idCard"></el-input>
            </el-form-item>
            <el-form-item label="身份认证类型">
                <el-radio-group v-model="authForm.identityType" @input="changeIdentityType">
                    <el-radio border :label="0">学生</el-radio>
                    <el-radio border :label="1">教师</el-radio>
                    <el-radio border :label="2">企业员工</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="authForm.identityType == 0" prop="teacherName">
                <template slot="label"><span style="color: #FF4A2B; margin-right: 5px;">*</span>导师名称</template>
                <el-input placeholder="请输入导师名称" v-model="authForm.teacherName"></el-input>
            </el-form-item>
            <el-form-item label="身份认证材料">
                <el-radio border :label="1" v-model="authForm.certType" v-show="authForm.identityType == 0 || authForm.identityType == 1">校园卡</el-radio>
                <el-radio border :label="2" v-model="authForm.certType" v-show="authForm.identityType == 0">学生证</el-radio>
                <el-radio border :label="3" v-model="authForm.certType" v-show="authForm.identityType == 0 || authForm.identityType == 1">学信网截图</el-radio>
                <el-radio border :label="4" v-model="authForm.certType" v-show="authForm.identityType == 2">营业执照</el-radio>
                <div v-if="authForm.certType != 4">
                    <div class="xuexin" v-if="authForm.certType == 3">
                        <img style="width: 60%" src="../../assets/img/auth/xuexiwang.jpg" alt="" srcset="" />
                        <div style="padding: 15px; color: #666666">
                            <span style="color: red">*</span>
                            {{ desc || '-' }}
                            <span style="color: #ffcf49">并与您填写的资料保持一致</span>
                        </div>
                    </div>
                    <div class="xuexin" v-if="authForm.certType == 2">
                        <div class="student_ex">
                            <img style="width: 20%" src="../../assets/img/auth/auth_student_up.png" alt="" srcset="" />
                            <img src="../../assets/img/auth/auth_student_down.png" alt="" srcset="" />
                        </div>
                        <div style="padding: 15px; color: #666666">
                            <span style="color: red">*</span>
                            {{ desc || '-' }}
                            <span style="color: #ffcf49">并与您填写的资料保持一致</span>
                        </div>
                    </div>
                    <div class="xuexin" v-if="authForm.certType == 1">
                        <div class="campus_card_ex">
                            <img src="../../assets/img/auth/auth_card_up.png" alt="" srcset="" />
                            <img src="../../assets/img/auth/auth_card_down.png" alt="" srcset="" />
                        </div>
                        <div style="padding: 15px; color: #666666">
                            <span style="color: red">*</span>
                            {{ desc || '-' }}
                            <span style="color: #ffcf49">并与您填写的资料保持一致</span>
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item :label="authForm.certType === 1 ? '校园卡正面:' : authForm.certType === 2 ? '学生证正面:' : authForm.certType === 3 ? '学习网截图' : ''" prop="upList">
                <uploadImage ref="uploadUpList" fileType="jpg,png,jpeg,JPG,PNG,JPEG" @getFile="uploadUpList"></uploadImage>
            </el-form-item>
            <el-form-item v-if="authForm.certType !== 3 && authForm.certType !== 4" :label="authForm.certType === 1 ? '校园卡反面:' : authForm.certType === 2 ? '学生证反面:' : ''" prop="downList">
                <uploadImage ref="uploadDownList" @getFile="uploadDownList"></uploadImage>
            </el-form-item>
            <el-form-item label="所在地区" prop="province">
                <el-cascader style="width: 100%;" placeholder="请选择所在地区" :options="regionData" v-model="authForm.provinceValue" @change="changeProvince"></el-cascader>
            </el-form-item>
            <el-form-item v-if="authForm.identityType != 2" label="所在高校" prop="collegesId">
                <el-select style="width: 100%;" filterable placeholder="请选择所在高校" v-model="authForm.collegesId" @change="changeSchool">
                    <el-option v-for="item in schoolOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="authForm.identityType != 2" label="所在院系" prop="facultyId">
                <el-select style="width: 100%;" placeholder="请选择所在院系" v-model="authForm.facultyId" @change="changeFaculty">
                    <el-option v-for="item in facultyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="authForm.identityType != 2" label="所在校区">
                <el-select style="width: 100%;" placeholder="请选择所在校区" v-model="authForm.campusId" @change="changeCampus">
                    <el-option v-for="item in campusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="authForm.identityType == 2" label="企业名称" prop="companyName">
                <el-input placeholder="请输入企业名称" v-model="authForm.companyName"></el-input>
            </el-form-item>
            <el-form-item label="详细地址">
                <el-input placeholder="请输入详细地址" v-model="authForm.address"></el-input>
            </el-form-item>
        </el-form>
        <div style="display: flex; justify-content: space-around; width: 80%;  margin-top: 100px;">
            <el-button type="primary" :loading="confirmLoading" @click="goBack">返回</el-button>
            <el-button type="primary" :loading="confirmLoading" @click="validateFormDate">提交</el-button>
        </div>
    </el-card>
</template>

<script>
import uploadImage from "@/pages/common/uploadImage.vue"
import { validEmail } from "@/plugins/validate";
import { getClient } from "@/plugins/auth";
import { schoolList, clientCertApply } from "@/api/request";
import { regionData, codeToText } from "element-china-area-data";

export default {
    components: { uploadImage },
    data() {
        const validemail = (rule, value, callback) => {
            if (value && !validEmail(value)) {
                return callback(new Error("请输入正确的邮箱"));
            }
            callback();
        };
        const valideTeacherName = (rule, value, callback) => {
            if (!value && this.authForm.identityType == 0) {
                return callback(new Error("请输入导师名称"));
            }
            callback();
        };
        
        return {
            confirmLoading: false,
            userInfo: {},
            authForm: {
                type: 1,// 申请类型 1 学生认证
				clientName: '',//客户昵称
				email: '',//邮箱
                name: '',//客户真实姓名
				cardType: undefined,//证件类型
                idCard: '',//客户证件号码
                identityType: 0,//客户身份类型  0=学生,1=教职工,2=公司员工
                teacherName: '',//关联导师名称
                certType: 1,//认证材料类型
                certPic: '',//认证图片地址
				upList: '',
				downList: '',
                colleges: '',//所在高校
				collegesId: undefined,//所在高校id
				faculty: '',//所在院系
				facultyId: undefined,//所在院系id
				campus: '',//所在校区
				campusId: undefined,//所在校区id 
                province: '',//所在地区
				provinceCode: undefined,//所在地区id
                provinceValue: undefined,//所在地区id的数组
                companyName: '',//企业名称
                address: '',//详细地址
            },
            rules: {
                clientName: [{ required: true, message: "昵称不能为空", trigger: "blur" },],
                email: [
                    { required: true, message: "邮箱不能为空", trigger: "blur" },
                    { validator: validemail, trigger: "blur" }
                ],
                name: [{ required: true, message: "真实姓名不能为空", trigger: "blur" },],
                idCard: [{ required: true, message: "证件号码不能为空", trigger: "blur" },],
                upList: [{ required: true, message: "请上传认证材料", trigger: "blur" },],
                downList: [{ required: true, message: "请上传认证材料", trigger: "blur" },],
                collegesId: [{ required: true, message: "所在高校不能为空", trigger: "blur" },],
                facultyId: [{ required: true, message: "所在院系不能为空", trigger: "blur" },],
                province: [{ required: true, message: "所在地区不能为空", trigger: "blur" },],
                companyName: [{ required: true, message: "企业名称不能为空", trigger: "blur" },],
                teacherName: [{ validator: valideTeacherName, trigger: "blur" },],
            },
            schoolOptions: [],//高校列表
            facultyOptions: [],//院校列表
            campusOptions: [],//校区列表
            regionData,//地区列表
        }
    },
    computed: {
        desc() {
            let desc = ''
            switch(this.authForm.certType) {
                case 1:
                    desc = '请上传您的校园卡正面+反面，上传的证件照片/截图中需含有您的真实姓名、所在高校/单位名称，'
                    break
                case 2:
                    desc = '请上传您的学生证封面，上传的证件照片/截图中需含有您的真实姓名、所在高校/单位名称，'
                    break
                case 3:
                    desc = '请您上传您在读学籍的学信网截图，上传的证件照片/截图中需含有您的真实姓名、学籍所在高校/单位名称，'
                    break
                case 4:
                    desc = '请请您上传您所在的企业营业执照，上传的证件照片/截图中需含有企业名称、税号等信息，'
                    break
            }
            return desc
        }
    },
    watch: {
        'authForm.certType'(newValue) {
            switch(newValue) {
                case 0:
					this.authForm.companyName = undefined
					break
				case 1: 
					this.authForm.companyName = undefined
					break
				case 2:
					this.authForm.colleges = undefined
					this.authForm.collegesId = undefined
					this.authForm.faculty = undefined
					this.authForm.facultyId = undefined
					this.authForm.campus = undefined
					this.authForm.campusId = undefined
					break
            }
            this.authForm.certPic = ''
            this.authForm.upList = ''
            this.authForm.downList = ''
            if(this.$refs.uploadUpList) {
                this.$refs.uploadUpList.cleanList()
            }
            if(this.$refs.uploadDownList) {
                this.$refs.uploadDownList.cleanList()
            }
        },
        'authForm.identityType'(newValue) {
            if(newValue == 2) {
                this.authForm.colleges = undefined
                this.authForm.collegesId = undefined
                this.authForm.faculty = undefined
                this.authForm.facultyId = undefined
                this.authForm.campus = undefined
                this.authForm.campusId = undefined
            } else {
                this.authForm.province = undefined
                this.authForm.provinceCode = undefined
                this.authForm.provinceValue = undefined
                this.authForm.companyName = undefined
            }
        },
    },
    async created() {
        this.userInfo = JSON.parse(getClient())
        this.authForm.clientName = this.userInfo.clientName
        const provinceList = this.userInfo.provinceCode ? this.userInfo.provinceCode.split(',') : []
        await this.changeProvince(provinceList)
        await this.changeSchool(this.userInfo.collegesId)
        this.changeFaculty(this.userInfo.facultyId)
        this.changeCampus(this.userInfo.campusId)
		this.authForm.companyName = this.userInfo.companyName
    },
    methods: {
        //选择身份认证类型
        changeIdentityType(e) {
            switch(e) {
                case 0:
                    this.authForm.certType = 1
                    break
                case 1:
                    this.authForm.certType = 1
                    break
                case 2:
                    this.authForm.certType = 4
                    break
            }
        },
        //上传图片
        uploadUpList(list) {
            this.authForm.upList = list[0].url
            if(list.length <= 0){
                this.$message.warning(`请上传相关附件`);
            }
        },
        uploadDownList(list) {
            this.authForm.downList = list[0].url
            if(list.length <= 0){
                this.$message.warning(`请上传相关附件`);
            }
        },
        //选择地区
        async changeProvince(value) {
            this.authForm.provinceValue = value;
            this.authForm.provinceCode = value.toString();
            this.authForm.province = this.getCodeToText(value);
            this.authForm.colleges = undefined
            this.authForm.collegesId = undefined
            this.authForm.faculty = undefined
            this.authForm.facultyId = undefined
            this.authForm.campus = undefined
            this.authForm.campusId = undefined
            const params = {
              type: 1,
              areaCode: this.authForm.provinceCode.split(',')[0],
            }
            const res = await schoolList(params)
            this.schoolOptions = res.data.map(item => {
                return {
                    label: item.schoolName,
                    value: item.schoolId,
                }
            })
        },
        //把区域码转成汉字
        getCodeToText(value) {
            var name = "";
            value.map(item => (name += codeToText[item] + "/"));
            return name;
        },
        //选择学校
        async changeSchool(e) {
            const schoolInfo = this.schoolOptions.find(item => item.value == e)
            this.authForm.colleges = schoolInfo.label
            this.authForm.collegesId = schoolInfo.value
            this.authForm.faculty = undefined
            this.authForm.facultyId = undefined
            this.authForm.campus = undefined
            this.authForm.campusId = undefined
            //查询所在院系下拉
            const facultyRes = await schoolList({type: 2, parentId: schoolInfo.value})
            //查询所在校区下拉
            const campusRes = await schoolList({type: 3, parentId: schoolInfo.value})
            this.facultyOptions = facultyRes.data.map(item => {
                return {
                    label: item.schoolName,
                    value: item.schoolId,
                }
            })
            this.campusOptions = campusRes.data.map(item => {
                return {
                    label: item.schoolName,
                    value: item.schoolId,
                }
            })
        },
        //选择院系
        changeFaculty(e) {
            const facultyInfo = this.facultyOptions.find(item => item.value == e)
            this.authForm.faculty = facultyInfo.label
            this.authForm.facultyId = facultyInfo.value
            this.authForm.campus = undefined
            this.authForm.campusId = undefined
        },
        //选择校区
        changeCampus(e) {
            const campusInfo = this.campusOptions.find(item => item.value == e)
            this.authForm.campus = campusInfo ? campusInfo.label : ''
            this.authForm.campusId = campusInfo ? campusInfo.value : null
        },
        //返回个人资料页
        goBack() {
            this.$emit('gotoPage', '1-2')
        },
        //提交身份认证申请
        validateFormDate() {
            const keyList = ['upList', 'downList']
            const fileList = []
            keyList.forEach(item => {
                if(this.authForm[item]) {
                    fileList.push(this.authForm[item])
                }
            })
            this.authForm.certPic = JSON.stringify(fileList)
            this.$refs.authForm.validate(valid => {
                if(valid) {
                    this.confirmLoading = true
                    clientCertApply(this.authForm).then(() => {
                        this.confirmLoading = false
                        this.$message.success('身份认证申请提交成功')
                        this.$emit('gotoPage', '1-2')
                    }).catch(() => {
                        this.confirmLoading = false
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
}

.authForm {
    width: 80%;
    margin: 0 auto;
    .xuexin {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 20px;
        .student_ex{
            display: flex;
            justify-content: space-around;
            img{
                width: 35%;
                height: 35%;
            }
        }
        .campus_card_ex{
            display: flex;
            justify-content: space-around;
            img{
                width: 45%;
            }
        }
    }
}
</style>